// Copyright (c) 2022 Onur Cinar. All Rights Reserved.
// https://github.com/cinar/indicatorts

/**
 * Indicator trend.
 */
export enum Trend {
  FALLING = -1,
  STABLE = 0,
  RISING = 1,
}
